import Bodycontent from "./bodycontent";
import Sidebar from "./sidebar";
import Header from "./header";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVideos } from "../actions/videoaction";
import { Helmet } from "react-helmet";
import Seo from "./Helmet";
import { Audio } from "react-loader-spinner";

const Layout = () => {
  const { videoId } = useParams();
  const videos = useSelector((state) => state.videoData);
  const { Loading } = useSelector((state) => state.videoData);
  console.log(Loading);
  const dispatch = useDispatch();
  useEffect(() => {
    console.log("videoId");
    dispatch(fetchVideos(videoId));
  }, []);

  return (
    <div>
      <div className="flex flex-row h-90vh">
        {Loading ? (
          <div className="flex flex-row justify-center mr-auto ml-auto mt-9 ">
            <Audio
              height="280"
              width="280"
              radius="9"
              color="black"
              ariaLabel="loading"
              wrapperStyle
              wrapperClass
            />
          </div>
        ) : (
          <>
            {/*<Seo Image={videos.videos.VidoeImage} videoId={videoId} />*/}
            <Sidebar video={videos.videos} videoId={videoId} />
            <Bodycontent video={videos.videos} videoId={videoId} />
          </>
        )}

        {/* Nested routes will render here */}
      </div>
    </div>
  );
};
export default Layout;
